/* Cute Things: nameplate and chain renderer, built from the Build your own editor's drawing code. */
(function (w) {
  var C = w.CTC, K = w.CTK;
  if (!C || !K) return;
  var PAL = C.PAL, el = K.el, fontOf = K.fontOf, CIRC = K.CIRC, uid = 0;

  function layout(R, tries) {
    var o = R.o, S = R.S, f = fontOf(o.font), name = (o.name || '').trim() || 'Amira', P = PAL[o.metal] || PAL.gold;
    var dainty = o.size === 'dainty', fs = dainty ? 112 : 140, th = f.th * (dainty ? .7 : 1) + (o.finish === 'stone' ? 5 : 0);
    var shapes = R.q('shapes'); shapes.replaceChildren(); shapes.removeAttribute('transform');
    R.q('stones').replaceChildren(); R.q('extr').replaceChildren();
    var face = 'url(#' + S + 'fg-' + (PAL[o.metal] ? o.metal : 'gold') + ')', base = R.q('base');
    base.setAttribute('fill', face); base.setAttribute('stroke', face);
    R.q('spec').setAttribute('specularConstant', o.finish === 'frosted' ? .35 : .95);
    var t = el('text', { x: 0, y: 0, 'font-family': '"' + f.fam + '"', 'font-weight': f.w, 'font-size': fs, 'letter-spacing': (f.ls * fs).toFixed(1), 'stroke-width': th, 'stroke-linejoin': 'round' });
    t.textContent = name; shapes.appendChild(t);
    var tb = t.getBBox();
    if (!tb.width) { if ((tries || 0) < 25) setTimeout(function () { if (!R.dead) layout(R, (tries || 0) + 1); }, 160); return; }
    var nch = Array.from(name).length;
    var charBox = function (i) { try { var e = t.getExtentOfChar(i); return { x: e.x, w: e.width }; } catch (er) { return { x: tb.x + tb.width * i / nch, w: tb.width / nch }; } };
    var endChar = function (dir) { var a = charBox(0), b = charBox(nch - 1); return ((dir < 0) === (a.x <= b.x)) ? a : b; };
    var bb = shapes.getBBox();
    var inside = K.buildMask(bb, f, name, t, fs, th).inside;
    var sc = dainty ? .82 : 1, Rr = 10.5 * sc, rh = 4.6 * sc, loops = [];
    [-1, 1].forEach(function (dir) {
      var cb = endChar(dir), x0 = cb.x - 6, x1 = cb.x + cb.w + 6, top = null, bot = null;
      for (var y = bb.y; y <= bb.y + bb.height; y += 1) { var any = false; for (var x = x0; x <= x1; x += 1.5) if (inside(x, y)) { any = true; break; } if (any) { if (top === null) top = y; bot = y; } }
      if (top === null) { top = tb.y; bot = tb.y + tb.height; }
      var yc = top + Math.max(5, (bot - top) * .2), ex = null, ey = yc;
      for (var dy = 0; dy <= 12 && ex === null; dy += 2) {
        [yc + dy, yc - dy].forEach(function (yy) {
          for (var x = dir < 0 ? x0 : x1; dir < 0 ? x <= x1 : x >= x0; x -= dir) { if (inside(x, yy)) { if (ex === null || (dir < 0 ? x < ex : x > ex)) { ex = x; ey = yy; } break; } }
        });
      }
      if (ex === null) ex = dir < 0 ? x0 : x1;
      var cx = ex + dir * Rr * .9, cyy = ey - Rr * .2; loops.push([cx, cyy]);
      shapes.appendChild(el('path', { d: 'M' + (cx - dir * (rh + 1.4)).toFixed(1) + ' ' + cyy.toFixed(1) + 'L' + (ex - dir * 2).toFixed(1) + ' ' + ey.toFixed(1), fill: 'none', 'stroke-width': (Rr * 1.05).toFixed(1), 'stroke-linecap': 'round' }));
      shapes.appendChild(el('path', { d: CIRC(cx, cyy, Rr) + CIRC(cx, cyy, rh), 'fill-rule': 'evenodd', stroke: 'none' }));
    });
    var bb2 = shapes.getBBox();
    var k = Math.min(1.6, (dainty ? 470 : 600) / bb2.width, (dainty ? 190 : 240) / bb2.height);
    var plateY = 560, tx = 500 - (bb2.x + bb2.width / 2) * k, ty0 = plateY - (bb2.y + bb2.height / 2) * k;
    var T = 'translate(' + tx.toFixed(2) + ' ' + ty0.toFixed(2) + ') scale(' + k.toFixed(4) + ')';
    shapes.setAttribute('transform', T); R.q('stones').setAttribute('transform', T);
    var ex2 = R.q('extr');
    for (var i = 4; i >= 1; i--) ex2.appendChild(el('use', { href: '#' + S + 'shapes', transform: 'translate(' + (i * .45).toFixed(2) + ' ' + (i * .9).toFixed(2) + ')', fill: P.dark, stroke: P.dark }));
    var over = R.q('over');
    if (o.finish === 'frosted') { over.setAttribute('fill', '#fff'); over.setAttribute('stroke', '#fff'); over.setAttribute('filter', 'url(#' + S + 'frost)'); over.setAttribute('opacity', '.8'); }
    else over.setAttribute('opacity', '0');
    if (o.finish === 'stone') {
      var ps = K.placeStones(bb, inside, name.length), g = R.q('stones'); g.setAttribute('color', P.bezel);
      var html = '', sp = '';
      ps.pts.forEach(function (pt, i) {
        html += '<use href="#' + S + 'stone" transform="translate(' + pt[0].toFixed(1) + ' ' + pt[1].toFixed(1) + ') scale(' + (ps.r / 6.3).toFixed(3) + ') rotate(' + ((i * 137) % 360) + ')"/>';
        if ((i * 53) % 7 === 0) sp += '<use href="#' + S + 'spark" transform="translate(' + (pt[0] - ps.r * .25).toFixed(1) + ' ' + (pt[1] - ps.r * .3).toFixed(1) + ') scale(' + (ps.r / 6.5 * (.7 + ((i * 29) % 10) / 20)).toFixed(3) + ') rotate(' + ((i * 17) % 45) + ')"/>';
      });
      g.innerHTML = html + '<g filter="url(#' + S + 'glow)" opacity=".95">' + sp + '</g>';
    }
    /* the metal gradient follows the plate, and filters only cover the plate, so many cards stay light */
    ['gold', 'silver', 'rose'].forEach(function (m) { var gr = R.svg.querySelector('#' + S + 'fg-' + m); gr.setAttribute('x1', bb2.x); gr.setAttribute('y1', bb2.y); gr.setAttribute('x2', bb2.x + bb2.width); gr.setAttribute('y2', bb2.y + bb2.height); });
    var rx = tx + bb2.x * k - 30, ry = ty0 + bb2.y * k - 30, rw = bb2.width * k + 60, rh2 = bb2.height * k + 60;
    ['face', 'frost'].forEach(function (n) { var fl = R.q(n); fl.setAttribute('x', rx.toFixed(1)); fl.setAttribute('y', ry.toFixed(1)); fl.setAttribute('width', rw.toFixed(1)); fl.setAttribute('height', rh2.toFixed(1)); });
    var dr = R.q('drop'); dr.setAttribute('x', (rx - 20).toFixed(1)); dr.setAttribute('y', (ry - 20).toFixed(1)); dr.setAttribute('width', (rw + 40).toFixed(1)); dr.setAttribute('height', (rh2 + 100).toFixed(1));
    var bottom = ty0 + (bb2.y + bb2.height) * k, floor = bottom + 10;
    R.q('refl').setAttribute('transform', 'translate(0 ' + (2 * floor).toFixed(1) + ') scale(1 -1)');
    var fg = R.q('fadeG'); fg.setAttribute('y1', floor.toFixed(1)); fg.setAttribute('y2', (floor + 140).toFixed(1));
    R.holes = loops.map(function (l) { return [tx + l[0] * k, ty0 + l[1] * k]; });
    R.P = P;
    drawChain(R);
    if (R.onready) R.onready(R);
  }

  function drawChain(R) {
    if (!R.holes) return;
    var o = R.o, S = R.S, P = R.P, cs = o.cs || 2.2, out = '';
    R.holes.forEach(function (h, side) {
      var dir = side === 0 ? -1 : 1, hx = h[0], hy = h[1];
      var pts = [[hx, hy], [hx + dir * (hy + 40) * .27, -40]];
      var off = o.chain === 'stella' ? 7 * cs : 0;
      if (off) { var x0 = pts[0][0], y0 = pts[0][1], L0 = Math.hypot(pts[1][0] - x0, pts[1][1] - y0); pts[0] = [x0 + (pts[1][0] - x0) / L0 * off, y0 + (pts[1][1] - y0) / L0 * off]; }
      out += C.chainSVG(pts, P, cs, o.chain, S);
      var a = Math.atan2(pts[1][1] - hy, pts[1][0] - hx) * 180 / Math.PI + 90;
      out += '<g transform="translate(' + hx.toFixed(1) + ' ' + hy.toFixed(1) + ') rotate(' + a.toFixed(1) + ') scale(' + cs + ')"><ellipse rx="5.6" ry="2.6" fill="none" stroke="' + P.dark + '" stroke-width="2.6"/><ellipse rx="5.6" ry="2.6" fill="none" stroke="' + P.mid + '" stroke-width="1.8"/></g>';
    });
    R.q('chain').innerHTML = out;
  }

  function create(host, opts) {
    K.ensureFonts();
    var S = 'ctr' + (++uid) + '-';
    var R = { S: S, o: Object.assign({ name: 'Amira', font: 'D24', metal: 'gold', finish: 'glossy', chain: 'link', size: 'regular', cs: 2.2 }, opts || {}), holes: null, token: 0, dead: false };
    var svg = document.createElementNS(K.NS, 'svg');
    svg.setAttribute('viewBox', '0 0 1000 1000'); svg.setAttribute('role', 'img'); svg.setAttribute('aria-hidden', 'true');
    svg.style.cssText = 'display:block;width:100%;height:100%';
    svg.innerHTML = K.markup(S);
    host.appendChild(svg);
    R.svg = svg;
    R.q = function (n) { return svg.querySelector('#' + S + n); };
    R.render = function () {
      var tok = ++R.token, f = fontOf(R.o.font), nm = (R.o.name || '').trim() || 'Amira';
      var p = (document.fonts && document.fonts.load) ? document.fonts.load(f.w + ' 140px "' + f.fam + '"', nm) : Promise.resolve();
      return p.catch(function () {}).then(function () { if (tok === R.token && !R.dead) layout(R, 0); });
    };
    R.update = function (p) {
      var o = R.o, re = false, ch = false;
      for (var k in p) { if (o[k] !== p[k]) { if (k === 'chain') ch = true; else re = true; o[k] = p[k]; } }
      if (re) R.render(); else if (ch) drawChain(R);
    };
    R.destroy = function () { R.dead = true; if (svg.parentNode) svg.parentNode.removeChild(svg); };
    R.render();
    return R;
  }
  w.CTRender = { create: create };
})(window);